// CSUMB BSCS Computer Science Concentration courses

export const cst300 = "cst300";
export const cst329 = "cst329";
export const cst334 = "cst334";
export const cst338 = "cst338";
export const cst370 = "cst370";
export const cst328 = "cst328";
export const cst462S = "cst462S";
export const cst499 = "cst499";
export const cst311 = "cst311";
export const cst336 = "cst336";
export const cst363 = "cst363";
export const cst383 = "cst383";
export const cst438 = "cst438";
export const cst231 = "cst231";
export const cst237 = "cst237";
export const cst238 = "cst238";
export const math130 = "math130";
export const math150 = "math150";
export const math151 = "math151";
export const math170 = "math170";

// Harvard Extension School AI Graduate Certificate courses
export const cscie25 = "cscie25";
export const cscie89B = "cscie89B";
export const cscie101 = "cscie101";
export const cscie184 = "cscie184";

// Harvard Extension School ALM Data Science courses
export const cscie106 = "cscie106";
